import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import Field from '../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { getInitialValues, validationSchema } from './fields'
import { MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../fields'
import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const DimensionsSectionForm = ({ editItemData: ad, successSubmit, isInternalAd, title, ...formProps }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const { id, account: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => getInitialValues(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAd(
          {
            account: adAccount,
            dimensions: {
              [MEDIA_WIDTH]: values[MEDIA_WIDTH],
              [MEDIA_HEIGHT]: values[MEDIA_HEIGHT]
            },
            ...(isInternalAd && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          id,
          DV_360_PLATFORM
        )
      )
    },
    [dispatch, id, isInternalAd, adAccount, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <FieldLabelWrapper label={t('Width')} labelFor={MEDIA_WIDTH}>
        <Field placeholder={t('Width')} formik={formik} name={MEDIA_WIDTH} type="number" decimalScale={0} />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Height')} labelFor={MEDIA_HEIGHT}>
        <Field placeholder={t('Height')} formik={formik} name={MEDIA_HEIGHT} type="number" decimalScale={0} />
      </FieldLabelWrapper>
    </EditForm>
  )
}

export default DimensionsSectionForm
